import { render } from "./AutocompleteAddress.vue?vue&type=template&id=4af54451&scoped=true"
import script from "./AutocompleteAddress.vue?vue&type=script&lang=js"
export * from "./AutocompleteAddress.vue?vue&type=script&lang=js"

import "./AutocompleteAddress.vue?vue&type=style&index=0&id=4af54451&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af54451"]])

export default __exports__